import useSWR from "swr";
import { Clock } from "lucide-react";
import { format } from "date-fns";
import { fixCalendarDate } from "../utils/dateHandlers.ts";

interface AvailableSlotsResponse {
  availableSlots: string[];
  selectedDate: string;
}

const SelectedDateSlots = ({
  selectedDate,
  onSlotSelected,
  selectedTime,
}: {
  selectedDate: Date | null;
  selectedTime: string | null;
  onSlotSelected: (slot: string) => void;
}) => {
  const { isLoading, data } = useSWR<AvailableSlotsResponse>(
    selectedDate
      ? `/api/schedule?date=${fixCalendarDate(selectedDate).toISOString()}`
      : null
  );

  const { availableSlots } = data || {};

  if (!selectedDate) {
    return (
      <p className="text-gray-500 text-center py-8">
        Vă rugăm selectați o dată pentru a vedea pozițiile disponibile.
      </p>
    );
  }

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-4">
        <div className="flex items-center justify-center p-4 rounded-lg bg-gray-200 h-[58px]" />
        <div className="flex items-center justify-center p-4 rounded-lg bg-gray-200 h-[58px]" />
        <div className="flex items-center justify-center p-4 rounded-lg bg-gray-200 h-[58px]" />
        <div className="flex items-center justify-center p-4 rounded-lg bg-gray-200 h-[58px]" />
        <div className="flex items-center justify-center p-4 rounded-lg bg-gray-200 h-[58px]" />
        <div className="flex items-center justify-center p-4 rounded-lg bg-gray-200 h-[58px]" />
        <div className="flex items-center justify-center p-4 rounded-lg bg-gray-200 h-[58px]" />
        <div className="flex items-center justify-center p-4 rounded-lg bg-gray-200 h-[58px]" />
        <div className="flex items-center justify-center p-4 rounded-lg bg-gray-200 h-[58px]" />
      </div>
    );
  }

  if (!availableSlots || !availableSlots.length) {
    const formattedDate = format(selectedDate, "dd/MM/yyyy");

    return (
      <p className="text-gray-500 text-center py-8">
        {`Ne pare rău, nu există niciun loc liber în data de ${formattedDate}.`}
      </p>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4">
      {availableSlots.map((time) => (
        <button
          key={time}
          onClick={() => onSlotSelected(time)}
          className={`
                      flex items-center justify-center p-4 rounded-lg
                      ${selectedTime === time ? "bg-red-600 text-white" : "bg-white border border-gray-200 hover:border-red-600"}
                    `}
        >
          <Clock
            className={`mr-2 ${selectedTime === time ? "text-white" : "text-red-600"}`}
            size={20}
          />
          {time}
        </button>
      ))}
    </div>
  );
};

export default SelectedDateSlots;
